import { selectedProcessIdAtom } from '../../atoms/workspace';
import { Text, UnstyledButton } from '@mantine/core';
import cx from 'clsx';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useAtom } from 'jotai';
import { ListTodo, MessageSquareText, Pin, StarIcon } from 'lucide-react';

dayjs.extend(relativeTime);

/**
 * Top 5 neglected: largest star = most neglected
 */
const starSizes = [20, 18, 16, 14, 12];

export type ProcessCardProps = {
  readonly commentsCount: number;
  readonly id: string;
  readonly incompleteTodosCount: number;
  readonly isPinned: boolean;
  readonly lastActivityAt: Date;
  readonly neglectRank: number;
  readonly onSelect?: () => void;
  readonly title: string;
};

export const ProcessCard = ({
  commentsCount,
  id,
  incompleteTodosCount,
  isPinned,
  lastActivityAt,
  neglectRank,
  onSelect,
  title,
}: ProcessCardProps) => {
  const [selectedId, setSelectedId] = useAtom(selectedProcessIdAtom);
  const isSelected = selectedId === id;
  const showStar = !isPinned && neglectRank < 5;

  return (
    <UnstyledButton
      className={cx(
        'text-left p-2.5 mb-1',
        isSelected
          ? 'w-full bg-[#faf8f5] dark:bg-[#2a2f36] border border-black/15 dark:border-white/15 md:rounded-l-md md:border-r-0'
          : 'w-full md:w-[calc(100%-0.5rem)] rounded-md hover:bg-black/5 dark:hover:bg-white/5',
      )}
      onClick={() => {
        setSelectedId(id);
        onSelect?.();
      }}
    >
      <div className="flex items-start gap-1.5">
        {isPinned && (
          <Pin
            className="shrink-0 mt-0.5 rotate-45 [--icon-color:#ff8300]"
            color="var(--icon-color)"
            fill="var(--icon-color)"
            size={14}
          />
        )}
        {showStar && (
          <StarIcon
            className="shrink-0 mt-0.5 [--icon-color:#ddd353]"
            color="var(--icon-color)"
            fill="var(--icon-color)"
            style={{
              height: starSizes[neglectRank],
              width: starSizes[neglectRank],
            }}
          />
        )}
        <Text className="text-sm leading-snug wrap-break-word min-w-0">
          {title}
        </Text>
      </div>

      <div className="flex items-center gap-2 mt-1 text-xs text-black/40 dark:text-white/40">
        <span>{dayjs(lastActivityAt).fromNow()}</span>
        {commentsCount > 0 && (
          <span className="inline-flex items-center gap-0.5">
            {commentsCount}
            <MessageSquareText size={12} />
          </span>
        )}
        {incompleteTodosCount > 0 && (
          <span className="inline-flex items-center gap-0.5">
            {incompleteTodosCount}
            <ListTodo size={12} />
          </span>
        )}
      </div>
    </UnstyledButton>
  );
};
